import { vm } from "../socket/config.js";
import { getBlock } from "../blocks/index.js";

export const stageName = "jHHVSbKjDsRhSWhIlYtd...___+_0)0+-";

const LOCAL_FLAG_TIMEOUT_MS = 6000;

let isLocalFlag = false;
let localFlagWatchdog = null;

export const getLocalFlag = () => {
    return isLocalFlag;
};
export const setLocalFlag = (isLocal) => {
    isLocalFlag = isLocal;

    if (localFlagWatchdog) {
        clearTimeout(localFlagWatchdog);
        localFlagWatchdog = null;
    }

    if (isLocal) {
        localFlagWatchdog = setTimeout(() => {
            isLocalFlag = false;
            localFlagWatchdog = null;
        }, LOCAL_FLAG_TIMEOUT_MS);
    }
};

export function targetToName(target) {
    return target?.isStage ? stageName : target?.sprite?.name;
}

export function nameToTarget(name) {
    return name == stageName
        ? vm.runtime.getTargetForStage()
        : vm.runtime.getSpriteTargetByName(name);
}

export function isVariableExistsGlobally(variableName) {
    const stage = vm.runtime.getTargetForStage();
    for (const [id, variable] of Object.entries(stage.variables)) {
        if (variable.name === variableName) return true;
    }
    return false;
}

export function isBadToSend(event, target) {
    switch (event.type) {
        case "create":
            if (event.xml.nodeName == "SHADOW") {
                return true;
            }
        case "delete":
            if (event.oldXml?.nodeName == "SHADOW") {
                return true;
            }
        case "move": {
            let block = target.blocks.getBlock(event.blockId);
            if (block?.shadow) {
                return true;
            }
        }
    }
    return false;
}

export function isBadToRunBlockly(event) {
    if (event.type === "create") return getBlock(event.blockId);
}

export function isBadToRun(event, target) {
    switch (event.type) {
        case "create":
            return !!target.blocks.getBlock(event.blockId);
        case "delete":
            return !target.blocks.getBlock(event.blockId);
        case "comment_create":
            return event.commentId in target.comments;
        case "move": {
            if (!target.blocks.getBlock(event.blockId)) return true;
            if (!!event.newCoordinate?.x && !!event.newCoordinate?.y) {
                let localBlock = target.blocks.getBlock(event.blockId);
                if (
                    Math.round(localBlock.x) ==
                        Math.round(event.newCoordinate.x) &&
                    Math.round(localBlock.y) ==
                        Math.round(event.newCoordinate.y)
                ) {
                    return true;
                }
            }
            if (!!event.newParentId) {
                let localBlock = target.blocks.getBlock(event.blockId);
                if (localBlock.parent == event.newParentId) {
                    return true;
                }
            }
        }
    }
    return false;
}
